import {
    DELETE_CAMPAIGN,
    DELETE_CAMPAIGN_FAILURE,
    DELETE_CAMPAIGN_SUCCESS,
} from 'store/actions/types';

export const deleteCampaign = (payload) => {
    return {
        type: DELETE_CAMPAIGN,
        payload: payload,
    };
};

export const deleteCampaignFailure = (error) => {
    return {
        type: DELETE_CAMPAIGN_FAILURE,
        error: error,
    };
};

export const deleteCampaignSuccess = (payload) => {
    return {
        type: DELETE_CAMPAIGN_SUCCESS,
        payload: payload,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/campaigns/deleteCampaigns.js